// Group switches for the welfare approval rule and the meeting call register.
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import api from '../utils/axios.ts';
import getApiErrorMessage from '../utils/helper.js';

export interface WorkflowSettings {
  welfare_vetting_enabled: boolean;
  welfare_vetting_approvals: number;
  call_register_enabled: boolean;
  call_register_fine_rates: Record<string, number>;
}

export const FINE_TYPE_LABELS: Record<string, string> = {
  late_comer: 'Late comer',
  disturbance: 'Disturbance',
  absent: 'Absent',
  absent_with_apology: 'Absent with apology',
  other: 'Other',
};

export const useWorkflowSettings = () =>
  useQuery<WorkflowSettings>({
    queryKey: ['workflow-settings'],
    queryFn: async () => (await api.get('/groups/workflow-settings')).data.data,
    staleTime: 60 * 1000,
  });

export const useUpdateWorkflowSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Partial<WorkflowSettings>) => (await api.post('/groups/workflow-settings', payload)).data.data as WorkflowSettings,
    onSuccess: (data) => {
      queryClient.setQueryData(['workflow-settings'], data);
      toast.success('Settings saved');
    },
    onError: (error: any) => toast.error(getApiErrorMessage(error) || 'Could not save the settings'),
  });
};
